<template>
  <div class="header" id="header">
    <div class="header_container">
      <div class="header_content flex_sb">
      <div class="header_mobile_menu flex_center ">
        <div class="header_logo hidden-xs-only" @click="toPage('')" >
          <img :src="logo" alt="">
        </div>
        <div class="icon-menu-line iconfont menu_icon" @click="menu_flag=true"></div>
      </div>
     
      <div class="header_menu flex_start_center ">
        <div class="md_hiddle flex_start_center header_menu">
          <span class="menu_tab tab_active flex_center" @click="toPage('')">{{$t('key0')}}</span>
          <span class="menu_tab flex_center " @mouseenter="menuFlag=true" @mouseleave="menuFlag=false">
            <span>{{$t('key2')}}</span>
            <span class="iconfont icon-down-line-free icon_tab flex_center" :style="{transform:menuFlag? 'rotate(180deg)':'rotate(0deg)'}"></span>
          </span>
          <span class="menu_tab flex_center" @click="toPage('/blog')">{{$t('key3')}}</span>

          <div class="draw_menu" v-if="menuFlag"  @mouseenter="menuFlag=true" @mouseleave="menuFlag=false">
            <div class="draw_menu_drop grid" >
              <div class="draw_menu_pop grid_md_8" >
                  <div class="pop_title flex" >
                    <div class="pop_img"><img src="../assets/icon/remenyouxi.png" alt=""></div>
                    <div>{{$t('key9')}}</div>
                  </div>
                  <div class="flex flex_warp">
                    <div class="pop_half " v-for="(item,index) in rankingList" :key="index" @click="toPage('/details',item.id,item.allName)">
                      <div class="pop_tab flex" >
                        <div class="pop_img"><img :src="item.upImage" alt=""></div>
                        <div>{{ item.tranName }}</div>
                      </div>
                    </div>
                  </div>
                  
              </div>
              
              <div class="draw_menu_pop grid_md_4 draw_menu_all">
                <div class="pop_title flex" >
                  <div class="pop_img"><img src="../assets/icon/suoyouyouxi.png" alt=""></div>
                  <div>{{$t('key10')}}</div>
                </div>
                <div class="all_games">
                  <div>
                    <div class="pop_tab flex" v-for="(item,index) in allGameList" :key="index" @click="toPage('/details',item.id,item.allName)">
                  
                      <div>{{ item.tranName }}</div>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>
      <div class="header_group flex_center" >
        <div class="search flex hidden-xs-only" @click="showSearch">
          <div class="icon-search iconfont search_icon flex_center"></div>
          <div class="search_box hidden-xs-only" :class="[showSearch_flag?'showSearch':'']">
            <el-input type="text"  placeholder="Search games or goods" v-model="search" @keyup.enter.native="onSearch"></el-input>
          </div>
          
        </div>
        <div class="search flex hidden-sm-and-up" style="margin-right:10px" @click="toPage('/search')">
          <div class="icon-search iconfont search_icon flex_center" style="width:30px;height: 30px;"></div>
         
          
        </div>
        <div class="btn_group flex_center hidden-xs-only" @click="setLang(true)" id="lang_btn">
            <span id="lang_text">{{ currency.dictDefaultLabel }} <span class="line"></span> {{ lang.dictDefaultLabel }}</span>
        </div>
        <div class="htn_group_min flex_center hidden-sm-and-up" @click="setLang(true)" id="lang_min_btn">
          <span class="gobal flex_center"><svg t="1731478966733" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1983" width="14" height="14"><path d="M180.096 903.104a509.056 509.056 0 0 0 288.192 120.832c-68.288-68.8-123.2-138.432-164.48-208.832a555.84 555.84 0 0 0-123.712 88zM721.408 811.52c-41.6 71.552-97.216 142.528-166.72 212.48a509.184 509.184 0 0 0 294.4-125.44l-8.576-8.128a646.144 646.144 0 0 0-119.104-78.976zM1024 526.464h-211.84c-5.184 85.12-29.696 169.664-73.344 253.44 41.984 21.312 83.328 48.704 123.904 82.112l5.632 4.672 7.552 6.592A513.024 513.024 0 0 0 1024 526.464zM361.024 88.32C388.544 52.992 415.68 23.872 438.4 1.6a509.056 509.056 0 0 0-248.64 109.312c18.56 16.96 55.168 47.424 105.472 75.136 18.944-33.344 40.96-66.048 65.792-97.856zM210.944 526.464H0a513.152 513.152 0 0 0 149.76 348.544l3.712 3.648c16.32-16 62.976-58.624 132.736-95.104-44.864-84.928-70.016-170.752-75.264-257.088zM336.384 799.488c39.424 66.56 91.712 132.8 156.672 198.272v-236.736c-40.32 2.304-80.64 10.432-120.64 24.32a491.648 491.648 0 0 0-36.032 14.144zM318.592 767.872c12.928-5.76 26.496-11.2 40.64-16.192a479.104 479.104 0 0 1 133.824-26.816v-198.4H247.04c5.312 80.768 29.248 161.344 71.68 241.344zM984 310.72A513.088 513.088 0 0 0 874.24 147.2l-0.64-0.64-3.712 0.192c-39.232 32.768-79.232 60.032-119.808 81.6 3.328 6.848 6.528 13.696 9.6 20.608 30.784 69.12 48.512 140.096 52.544 210.88 0.64 10.24 0.896 20.416 0.96 30.592h210.56a512.448 512.448 0 0 0-39.744-179.648zM210.816 459.776a603.072 603.072 0 0 1 52.544-210.944c3.648-8.128 7.488-16.256 11.52-24.384a587.584 587.584 0 0 1-117.696-84.608A513.088 513.088 0 0 0 0.192 490.368H209.92c0-10.176 0.32-20.352 0.896-30.592zM584.704 765.888a419.648 419.648 0 0 0-54.72-5.312v237.184c66.048-66.56 118.912-133.76 158.592-201.472a456.704 456.704 0 0 0-103.872-30.4zM706.176 764.544c41.344-78.912 64.64-158.4 69.888-238.08H529.984v197.952c19.84 0.64 39.744 2.496 59.52 5.696 39.232 6.336 78.144 17.856 116.672 34.432zM776.32 462.208a566.464 566.464 0 0 0-49.152-197.824c-2.944-6.784-6.08-13.44-9.344-20.16-42.112 19.136-84.736 32.256-127.68 39.168-20.032 3.2-40.064 5.12-60.16 5.76v201.216h247.232c0-9.408-0.32-18.816-0.832-28.16zM662.016 88.32c25.792 32.96 48.512 66.944 67.968 101.632 37.056-19.712 73.664-44.544 109.696-74.432A509.184 509.184 0 0 0 584.512 1.536c22.72 22.272 49.92 51.392 77.504 86.72zM388.608 111.488c-23.04 29.568-43.52 59.968-61.248 90.88 14.656 6.848 30.144 13.248 46.464 18.88 39.552 13.76 79.36 21.76 119.232 24V0c-24.96 22.08-64.512 60.16-104.448 111.488zM697.6 205.824a771.2 771.2 0 0 0-63.104-94.336A845.12 845.12 0 0 0 529.92 0v245.76c18.112-0.64 36.224-2.368 54.272-5.312a457.728 457.728 0 0 0 113.408-34.624zM306.944 240.704c-3.84 7.872-7.552 15.744-11.072 23.68a566.656 566.656 0 0 0-49.216 197.76 527.232 527.232 0 0 0-0.832 28.224h247.232V288.64a482.56 482.56 0 0 1-135.04-27.008 546.176 546.176 0 0 1-51.072-20.928z" p-id="1984" fill="#ffffff"></path></svg></span>
          <span id="lang_min_text">{{ currency.dictDefaultLabel }} <span class="line"></span>{{ lang.dictDefaultLabel }} </span>
        </div>
        <div class="btn_grouo_yellow flex_center "  @click="toLogin()" v-if="!token">
          <span>{{$t('key11')}} / {{$t('key12')}}</span>
           <!-- <img src="../assets/icon/user.png" alt=""> -->
        </div>
       
      </div>
      <div class="person flex_center" @mouseenter="userhand=true" @mouseleave="userhand=false" v-if="token">
          <div class="person_icon" @click="toPage('/personal')"><img :src="userInfo.image" alt="" ></div>
          <div class="person_container flex_col_center hidden-xs-only" v-show="userhand">
            <div class="con_head ">
              <img :src="userInfo.image" alt="">
            </div>
            <div class="user_id">{{ userInfo.nickName }}</div>
            <div class="user_point flex_center" @click="toPage('/affiliate')">
              <span class="point_icon"></span>
              <div class="point_text">{{$t('key13')}}</div>
              
            </div>
            <div class="person_list">
                <div class="list_tab flex_sb" v-for="(item,index) in userContent" :key="index" @click="toPersonal(item)">
                  <div class="tab_name" style="text-align: left;">{{ item.name }}</div>
                  <div class="tab_info flex_center">
                    <div class="point_icon " v-if="item.id==2"><img src="../assets/icon/point.jpg" alt=""></div>
                    <div class="info_msg">{{ item.content }}</div>
                    <div class="info_icon iconfont icon-enter-line-free flex_center"></div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      
    </div>
    </div>
    
    <el-drawer
      :visible.sync="menu_flag"
      :append-to-body="true"
      :with-header="false"
       direction="ltr" :size="320">
      <div class="mobile_menu_list">
        <div class="header_logo" @click="toPage('')">
          <img :src="logo" alt="">
        </div>
        <div class="mobile_menu_tab flex_sb" @click="toPage('')">
          <div class="menu_tab_title">{{$t('key1')}}</div>
          <div class="iconfont icon-enter-line-free more_icon"></div>
        </div>
        <div class="mobile_menu_tab flex_sb" @click="showMobileMenu=!showMobileMenu">
          <div class="menu_tab_title">{{$t('key2')}}</div>
          <div class="iconfont icon-enter-line-free more_icon"></div>
        </div>
        <div class="menu_list" :style="{'height':showMobileMenu?'auto':'0',transform:showMobileMenu? 'scaleY(1)':'scaleY(0)'}">
          <div class="menu_list_group" >
            <div class="menu_list_title">{{$t('key9')}}</div>
            <div class="meun_list_li flex_start_center" v-for="(item,index) in rankingList" :key="index" @click="toPage('/details',item.id,item.allName)">
              <div class="li_img"><img :src="item.upImage" alt=""></div>
              <div class="li_name">{{item.tranName}}</div>
            </div>
            <div class="menu_list_title">{{$t('key10')}}</div>
            <div class="meun_list_li flex_start_center" v-for="(i) in allGameList" :key="i.id" @click="toPage('/details',i.id,i.allName)">
              <div class="li_img"><img :src="i.upImage" alt=""></div>
              <div class="li_name">{{i.tranName}}</div>
            </div>
            
          </div>
        </div>
        <div class="mobile_menu_tab flex_sb"  @click="toPage('/blog')">
          <div class="menu_tab_title">{{$t('key3')}}</div>
          <div class="iconfont icon-enter-line-free more_icon"></div>
        </div>
      </div>
    </el-drawer>
    

    <!-- foot tabbar -->
    <!-- <div class="foot_tabbar hidden-sm-and-up" v-if="routerName=='index'||routerName=='personal' || routerName=='message'" >
      <div class="login_group flex" v-if="!token&&showMobileBtn">
        <div class="login_half flex_center" @click="leater()">Leater</div>
        <div class="login_half flex_center login_btn" @click="toLogin()">{{$t('key11')}}/{{$t('key12')}}</div>
      </div>
      <div class="tabbar flex">
        <div class="tabbar_tab">
          <div class="tab_icon flex_center" :class="[routerName=='index'?'is_active':'']" @click="toPage('')">
            <div class="icon_item flex_center"><svg t="1731485111819" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8801" width="24" height="24"><path d="M819.7 536.6c7.4 9 6.1 22.4-3.1 29.7C766 607 713 649.5 692.7 665.7 653 697.4 587.5 763.3 512 763.3c-76 0-142.1-66.8-180.7-97.7-19.7-15.7-73-58.4-124-99.4-9.1-7.3-10.5-20.7-3.1-29.7l26.7-32.4c7.3-8.9 20.4-10.2 29.3-3 50 40.2 102.4 82.2 123.4 98.9 30.7 24.5 86.9 79.4 128.3 79.4 41.3 0 96.6-54 128.3-79.4 21-16.7 73.3-58.7 123.4-98.9 9-7.2 22-5.8 29.3 3l26.8 32.5z m55.9 328.1c0 5.8-4.7 10.5-10.5 10.5H158.8c-5.8 0-10.5-4.7-10.5-10.5V421.3c0-3.2 1.4-6.2 3.9-8.2 27.7-22.4 190.2-153.1 231.4-185.8C415.4 201.9 470.7 148 512 148c41.4 0 97.7 54.8 128.3 79.4 41.2 32.8 203.7 163.5 231.4 185.9 2.5 2 3.9 5 3.9 8.2v443.2z m53.5-513c-8.2-6.8-195.3-157.3-236.5-190C654 130.8 587.9 64 512 64c-75.5 0-141 65.9-180.7 97.7-42.8 34-229.1 183.9-236.3 189.8-19.4 15.9-30.6 39.7-30.6 64.8v459c0 46.3 37.6 83.9 83.9 83.9h727.3c46.3 0 83.9-37.6 83.9-83.9v-459c0.1-25-11.1-48.7-30.4-64.6z" p-id="8802" fill="#1f2128"></path></svg></div>
          </div>
          <div class="tab_title">{{$t('key1')}} </div>
        </div>
        <div class="tabbar_tab" @click="toPage('/message')">
          <div class="tab_icon flex_center" :class="[routerName=='message'?'is_active':'']">
            <div class="icon_item flex_center"><svg t="1731485353962" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14890" width="24" height="24"><path d="M923.84 64H76.224C34.112 64 0 98.112 0 140.16v609.536c0 42.048 34.112 76.16 76.16 76.16h76.16L164.48 1024l292.608-198.144h466.688a76.16 76.16 0 0 0 76.224-76.16V140.16A76.16 76.16 0 0 0 923.84 64zM435.2 740.16l-210.304 152.448v-152.512H66.688V130.688h866.624v609.408l-498.176 0.064zM214.464 330.688v76.16h598.784v-76.16H214.464z m0 152.32v76.224h299.392v-76.16H214.464z" fill="#1f2128" p-id="14891"></path></svg></div>
          </div>
          <div class="tab_title">{{$t('key133')}} </div>
        </div>
        <div class="tabbar_tab" @click="toPage('/personal')">
          <div class="tab_icon flex_center" :class="[routerName=='personal'?'is_active':'']">
            <div class="icon_item flex_center"><svg t="1731485443669" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20214" width="24" height="24"><path d="M500.928 160.064l4.842667-0.064h12.949333c76.8 0 139.050667 62.250667 139.050667 139.050667v96.469333a145.770667 145.770667 0 0 1-43.648 104.021333l-42.794667 42.026667a67.562667 67.562667 0 0 0-20.224 48.192v6.016c0 25.173333 14.549333 48.085333 37.312 58.837333l295.808 139.392a39.104 39.104 0 0 1 22.442667 35.392v10.752c0 13.162667-10.666667 23.850667-23.850667 23.850667H141.184c-12.586667 0-23.04-9.813333-23.808-22.314667l-0.064-2.538666 0.021333-9.749334c0-14.293333 7.808-27.456 20.309334-34.304l2.986666-1.493333 294.954667-138.986667a65.024 65.024 0 0 0 37.013333-52.608l0.256-4.693333 0.042667-7.552c0-15.829333-5.546667-31.104-15.658667-43.242667l-3.456-3.818666-43.904-43.157334a145.770667 145.770667 0 0 1-43.562666-98.709333l-0.106667-5.909333v-95.872a139.050667 139.050667 0 0 1 134.72-138.986667z m-92.032 435.712L408.746667 597.333333c0.042667-0.490667 0-0.704-0.085334-0.746666L112.490667 736.128l-4.736 2.389333c-33.834667 18.517333-54.421333 53.162667-54.421334 90.88v10.752l0.128 4.522667C56.384 891.84 94.72 928 141.184 928h741.632a87.850667 87.850667 0 0 0 87.850667-87.850667v-10.752a103.104 103.104 0 0 0-59.157334-93.269333L615.701333 596.693333a1.024 1.024 0 0 1-0.597333-0.938666v-6.016c0-0.96 0.384-1.877333 1.066667-2.56l42.794666-42.005334a209.770667 209.770667 0 0 0 62.805334-149.674666v-96.469334A203.050667 203.050667 0 0 0 518.72 96h-13.44l-5.824 0.085333c-109.973333 3.370667-197.226667 93.184-197.226667 202.965334v96.469333l0.106667 7.061333a210.112 210.112 0 0 0 62.698667 142.613334l42.794666 42.026666 1.28 1.472c-0.512-0.576-0.213333 0.213333-0.213333 1.066667v6.016z" fill="#1f2128" p-id="20215"></path></svg></div>
          </div>
          <div class="tab_title">{{$t('key14')}} </div>
        </div>
      </div>
    </div> -->
    
  </div>
</template>

<script>
import cookies from '../utils/cookie';
import {processString} from '../utils/tool'
export default {
  inject:['reload'],
  data () {
    return {
      menuFlag:false,
      menu_flag:false,
      mobileMenuFlag:false,
      showMobileMenu:false,
      showSearch_flag:false,
      lang_flag:false,
      userhand:false,
      showMobileBtn:true,
      screenWidth: document.body.clientWidth,
      search:'',
     
      
      routerName:'',
      userContent:[
        // {name:'My Balance',id:1,path:'',content:'$0.00'},
        // {name:'My Points',id:2,path:'',content:'0.00'},
        {name:this.$t('key93'),id:3,path:'',content:''},
        // {name:'My Coupon ',id:4,path:'',content:''},
        {name:this.$t('key94'),id:5,path:'',content:''},
        {name:this.$t('key95'),id:6,path:'',content:''},
        {name:this.$t('key133') ,id:9,path:'',content:''},
        {name:this.$store.state.localName +" "+ this.$t('key34'),id:7,path:'',content:''},
        {name:this.$t('key681'),id:8,path:'',content:''},
      ],
      allGameList:[],
      rankingList:[],
      pageIndex:1,
      pageSize:20,
      logo:'',
    }
  },
  created(){
    this.getLogo()
    this.getRankingList()
    this.getAllGameList()
    this.routerName = this.$route.name
    console.log('routerName',this.routerName)
  },
  methods: {

    toLogin(){
      this.$store.commit('setShowDialog',true)
    },
    toPage(path,id,allName){
      this.showMobileMenu = false
      this.menu_flag = false
      let lang = localStorage.getItem('lang')
      if(id){
        let tranName = allName
        let name = ''
        let gameName = ''
        if(!/^\s*$/.test(allName)){
          if(typeof(allName) === 'string'){
            tranName = JSON.parse(allName)
          }            
          tranName.map(c=>{
            if(c.language =='1' ){
                name = c.name
            }  
          })
        }
        
        gameName = processString(name)
        this.$router.push(path+'/'+lang+'/'+id+'/'+gameName)
       
        return
      }
      this.$router.push(path+'/'+lang)
    },
    setLang(){
        this.$store.commit('setLang_flag',true)
    },
    showSearch(){
      console.log('show',this.screenWidth)
      if(this.screenWidth >1440){
        return
      }
      this.showSearch_flag = true
    },
    getRankingList(){
      let lang =this.$store.state.lang
      let currency = this.$store.state.currency
      let pageIndex = this.pageIndex
      let pageSize = this.pageSize
      let _this = this
      if(!lang||!currency){   
          setTimeout(()=>{
             _this.getRankingList() 
          },1000)
          return
      }
    
      this.$axiosApi.getRankingList({pageIndex,pageSize}).then(res=>{
        if(res.code == 200){
          let rankingList = res.data.list
          this.rankingList = rankingList.map(v=>{
            if(!/^\s*$/.test(v.allName)){
                v.allName = JSON.parse(v.allName)
                v.allName.map(c=>{
                  if(c.language ==lang.dictValue ){
                      v.tranName = c.name
                      return
                  }
                  if(c.language == '1'){
                      v.tranName = c.name  
                  }
              })
            }
             
              return v
          })
        }
        
      })
    },
    getAllGameList(){
      let lang =this.$store.state.lang
      let currency = this.$store.state.currency
      let _this = this
      if(!lang||!currency){   
          setTimeout(()=>{
                  _this.getAllGameList() 
          },1000)
          return
      }
      let gameAlias =''
      let pageIndex = this.pageIndex
      let pageSize = this.pageSize
      this.$axiosApi.getAllGameList({gameAlias,pageIndex,pageSize}).then(res=>{
        if(res.code == 200){ 
          this.allGameList = res.data.list.map(v=>{
            if(!/^\s*$/.test(v.allName)){
                v.allName = JSON.parse(v.allName)
                v.allName.map(c=>{
                 
                  if(c.language == lang.dictValue ){
                      v.tranName = c.name
                    return
                  } 
                  if(c.language == '1'){
                      v.tranName = c.name  
                  } 
              })
            } 
              return v
          })
        }  
      })
    },
    leater(){
      this.showMobileBtn = false
    },
    toPersonal(item){
      this.userhand = false
      if(item.id == 6){
        let lang = localStorage.getItem('lang') 
        this.$router.push('/faqs'+'/'+lang)
        return
      }
      if(item.id==8){
        // let lang = localStorage.getItem('lang') || 'en'
        //     this.$router.push(''+'/'+lang)
        //     location.reload()
        //     returm
        this.$axiosApi.logOut().then(res=>{
          if(res.code == 200){
            this.$message.success(res.msg)
            cookies.removeToken()
            // localStorage.setItem('lang','en')
            let lang = localStorage.getItem('lang') || 'en'
            this.$router.push('/')
            location.reload()
          }
        })
        return
      }
      let lang = localStorage.getItem('lang')
      this.$router.push('/personal'+'/'+lang+'/'+item.id)  
    },
    onSearch(){
      let search = this.search
      let lang = localStorage.getItem('lang')
      
      this.$router.push('/search'+'/'+lang+'/'+search)
      if(this.routerName == 'search'){
        // this.reload()
      }
    },
    getLogo(){
      let type=2
        let localeUrl = window.location.host
        let domain = 'https://'+localeUrl
        this.$axiosApi.getBannerList({type,domain}).then(res=>{
            if(res.code==200){
              this.logo=res.data[0].image
              this.$store.commit('setLogo',res.data[0].image)
            }
        })
    }
  

  
  },
  mounted () {
    window.onresize = () => {
      // console.log('screenWidth',this.screenWidth)
      this.screenWidth = window.innerWidth
      if(this.screenWidth >=1080){
        this.menu_flag = false
      }
      if(this.screenWidth >1440){
        this.showSearch_flag = false
      }
    } 
  },
  computed:{
    token(){ return cookies.getToken()},
    lang(){return this.$store.state.lang}, 
    currency(){ return this.$store.state.currency},
    userInfo(){return this.$store.state.userInfo},
  
  },
  watch: {
    '$route': {
      handler: function(newVal,oldVal) {
        this.routerName = newVal.name 
      } 
    },
   
   
  },
}
</script>

<style lang="scss" >
.header {
  // width: 100%;
 
 
  position: fixed;
  left:0;
  right:0;
  top:0;
  
  z-index: 99;
  .header_container{
    color:#16181c;
    height: 80px;
    font-size: 16px;
    background:$headerBg;
    padding:0 32px;
  }
  .showSearch{
    width: 190px!important;
  }
  .header_mobile_menu{
    
    .menu_icon{
      width: 48px;
      height: 48px;
      text-align: center;
      line-height: 48px;
      color:$el-wf2;
      font-size: 24px;
      background:$al-wal1;
      border-radius:4px;
      margin-right:30px;
     
      color:#fff;
      &:hover{
        opacity: 0.7;
      }
    }
    border-right: 1px solid #ffffff1a;
  }
  .header_content{
    height: 100%;
    position: relative;
    .header_logo{
      width: 180px;
      margin-right:80px;
      // height: 30px;
      // background: 0 0 / 180px 78px url(https://static.playsave.com/src/img/logo_playsave_web.8852761e.png) no-repeat;
      >img{
        width: 100%;
        height:auto;
      }
    }
    .header_menu{
      position: relative;
      margin-left:80px;
      height: 100%;
      flex:1;
      >span{
        color:$text-normal;
        margin-right:44px;
        height: 100%;
        cursor: pointer;
        &:hover{
          color:$white;
        }
        &:nth-child(3){
          margin-right:0;
          // &:hover{
          //   .icon_tab{
          //     transform: rotate(180deg);
          //   }
          // }
        }
      }
      .tab_active{
        position: relative;
        color: $text-yellow;
        &::before{
          content:'';
          height: 4px;
          left:0;
          right:0;
          top:0;
          border-radius: 2px;
          background: $bg-yellow;
          position: absolute;
        }
      }
      .icon_tab{
        font-size: 14px;
        margin-left:6px;
        transition: transform 0.3s ease-out;
        margin-top:2px;
      }
      .hamb_top{
        top:2px;
      }
    
      .draw_menu{
        transition: all 0.35s ease-in-out;
        position: fixed;
        left:0;
        right: 0;
        width: 1000px;
        top:79px;
        z-index: 1;
        // height: 400px;
        background-color:$bg-ht;
        overflow: hidden;
        height: 356px;
        // margin:0 auto;
        margin-left:280px;
        .draw_menu_pop{

          .pop_title{
            padding:14px 16px;
            font-size: 15px;
            color:$white;
            text-align: left;
            border-bottom:1px solid $inputColor;
            .pop_img{
              width: 20px;
              height: 20px;
              margin-right:4px;
            }
          }
          .pop_half{
            width: 50%;
           
          }
          .all_games{
            height: 100%;
            overflow: auto;
            scrollbar-width: none;
          }
          .pop_tab{
              padding:14px 16px;
              font-size: 15px;
              color:$white;
              cursor: pointer;
              &:hover{
                background:$bg-ho;
              }
              .pop_img{
                width: 20px;
                height: 20px;
                margin-right:4px;
              }
            }
        }
        .draw_menu_all{
          background: $bg-g;
          height: 396px;
        }
       
      }
    }
    .header_group{
      .search{
        position: relative;
        background:$inputColor;
        border:1px solid $inputColor;
        border-radius: 4px;
        overflow: hidden;
       
        &:hover{
            border-color:$bg-yellow;
          }
        .search_icon{
          background: transparent;
          font-size: 20px;
          color:$iconColor;
          position: relative;
          width: 48px;
          height: 48px;
          cursor: pointer;
          // z-index: 99;
        }
        .search_box{
          transition: all 0.25s ease-in;
          // width: 192px;
          overflow: hidden;
          
          // background:$inputColor;
        }
        .el-input__inner{
          height: 48px;
          line-height: 48px;
          width:100%;
          background:transparent;
          border:none;
          padding:0;
          color:#fff;
          &::placeholder{
            color:$iconColor;
          }
         
        }
        .el-input__prefix{
          left:10px
        }
        .el-input__icon{
          line-height: 48px;
          color:#fff;
          &::before{
            font-size: 20px;
          }
        }
      }
      .htn_group_min{
        color:#ffffff;
        font-size: 12px;
        height: 24px;
        padding:0 12px;
        margin-right:24px;
        border:1px solid hsla(0, 0%, 100%, .2);
        border-radius: 4px;
     
        cursor: pointer;
        .gobal{
          margin-right:6px;
        }
        &:hover{
          opacity: 0.8;
        }
        >span{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      .btn_group{
        height: 48px;
        margin:0 20px;
        color:$white;
        background:$inputColor;
        border-radius: 4px;
        padding:0 20px;
        cursor: pointer;
        width: 125px;
        transition: all 0.2s ease-in;
        >span{
          text-transform: uppercase;
          font-weight: 600;
        }
        &:hover{
          opacity: 0.7;
        }
        .line{
          width: 2px;
          height: 12px;
          background: $white;
          display: inline-block;
        }
      }
      .btn_grouo_yellow{
        color:#000!important;
        height: 48px;
        // width: 48px;
        overflow: hidden;
        background:$bg-yellow;
        color:$text-black;
        min-width: 240px;
        border-radius: 4px;
        cursor: pointer;
        &:hover{
          opacity: 0.7;
        }
      }
      
    }
    .person{
        position: relative;
        height: 100%;
       
      
        // overflow: hidden;
        .person_icon{
          width: 46px;
          height: 46px;
          border-radius: 50%;
   
          border: 1px solid #888;
          overflow: hidden;
        }
       
        .person_container{
          // padding-top:30px;
          background-color: #303030;
          position: absolute;
          z-index: 7999;
          top: 80px;
          right: 0;
          cursor: default;
          width: 296px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, .16);
          border-radius: 4px;
          color:#fcfcfc;
          font-size: 16px;
          .con_head{
            width: 64px;
            height: 64px;
            border-radius: 50%;
            border: 1px solid #888;
            overflow: hidden;
          }
          .user_id{
            margin-top:4px;
          }
          .user_point{
            margin-top:24px;
            padding:8px 12px;
            font-size: 14px;
            border: 1px solid #ffffff66;
            border-radius: 100px;
            .point_icon{
              margin-right: 5px;
              width: 16px;
              height: 16px;
              background: 50% / contain url(../assets/icon/gold.jpg) no-repeat;
            }
           
          }
          .person_list{
            font-family: BarlowMedium;
              margin-top:20px;
              width: 100%;
              .list_tab{
                padding:16px;
                cursor: pointer;
                &:hover{
                  opacity: 0.7;
                  background:#444;
                }
                .info_icon{
                  font-size:12px;
                  margin-left:8px;
                }
                .point_icon{
                  width: 20px;
                  height: 20px;
                  border-radius: 50%;
                  overflow: hidden;
                  margin-right: 6px;
                }
              }
            }
        }
      }
    
    
  }
  
  .foot_tabbar{
    position: fixed;
    bottom:0;
    left:0;
    right:0;
    .login_group{
      width: 100%;
     
      background-color: rgba(0, 0, 0, 0.6);
      padding: 16px;

      .login_half{
        width: 50%;
        font-size: 16px;
        color:#ffea60;
        height: 48px;
        border-radius: 4px;
        border:1px solid #ffcb2e;
        cursor: pointer;
        &:hover{
          opacity: 0.7;
        }
      }
      .login_btn{
        background:linear-gradient(89.92deg, #e477ff .07%, #9377ff);
        margin-left:16px;
        color:#ece8e1;
      }
    }
    .tabbar{
      height: 48px;
      background: #fff;
      width: 100%;
      box-shadow: 0 0 4px -1px rgba(0, 0, 0, .1), 0 0 5px 0 rgba(0, 0, 0, .08), 0 0 10px 0 rgba(0, 0, 0, .05);
      .tabbar_tab{
        width: 33.33%;
        position: relative;
        cursor: pointer;
        .is_active{
         
          background: #ffcb2e;
          border-radius: 50%;
          top: -10px !important;
        }
        .tab_icon{
          position: absolute;
          top:-6px;
          left:50%;
          transform: translate(-50%);
          // width:32px;
          // height: 32px;
          padding:6px;
        }
        .tab_title{
          text-align: center;
          line-height: 18px;
          font-size: 12px;
          color:#1f2128;
          padding-top:25px;
        }
      }
    }
  }
  
}

</style>